import { useGetUserCalenderInfo } from '@forwardflow/hooks/useGetUserCalenderInfo'
import { UserService } from '@forwardflow/services/UserService'
import FubInboxIntegration from '../FubInboxIntegration'
import GoogleCalendarIcon from '../../../assets/svg/GoogleCalendarIcon'

const CalendarIntegration = () => {
   const orgId = localStorage.getItem('currentOrganization')
   const { data: UserCalenderInfo } = useGetUserCalenderInfo(!!orgId)

   const isCalendarConnected = UserCalenderInfo && UserCalenderInfo.email

   const handleCalendarConnect = async () => {
      try {
         const redirectUrl = encodeURIComponent(
            `${window.location.origin}/dashboard`
         )
         const response = await UserService.getConnectUserWithCalender(
            redirectUrl,
            orgId || ''
         )

         if (response.redirectUrl) {
            window.location.href = response.redirectUrl
         }
      } catch (e) {
         console.error('Error connecting calendar:', e)
      }
   }

   return (
      <div className="flex flex-col items-center min-h-screen px-8 pt-6 ">
         <div className="w-full max-w-xl">
            <h2 className="mb-2 font-semibold text-white">Integration</h2>
            <p className="mb-16 text-sm text-white/70">
               Connect your tools to Forward Flow for seamless scheduling and
               communication.
            </p>
            <div className="flex flex-col gap-4 p-6 bg-[#828282]/10 rounded-lg shadow-lg max-w-96">
               <div className="mb-8">
                  <p className="mb-4 font-medium text-white">
                     {isCalendarConnected
                        ? 'Google Calendar connected'
                        : 'Google Calendar not connected'}
                  </p>
                  <p className="text-sm text-white/70">
                     {isCalendarConnected
                        ? `Connected to: ${UserCalenderInfo.email}`
                        : 'Connect your Google Calendar so Forward Flow can help schedule appointments.'}
                  </p>
               </div>
               {!isCalendarConnected && (
                  <button
                     onClick={handleCalendarConnect}
                     className="flex items-center h-10 gap-2 px-4 py-2 font-medium text-white transition-colors rounded-md bg-white/10 hover:bg-white/20"
                  >
                     <GoogleCalendarIcon />
                     Connect Google Calendar
                  </button>
               )}
            </div>
            <FubInboxIntegration />
         </div>
      </div>
   )
}

export default CalendarIntegration
